<template>
  <div class="mb-product-pile">
    <div class="product1">
      <img :src="require('@/assets/mobile/product1p.png')"/>
    </div>
    <div class="product2">
      <img :src="require('@/assets/mobile/product2p.png')"/>
      <div class="desc">
        <p>国恒充电智慧交流充电桩</p>
        <p>HD-AC7MP200</p>
        <p>精工打造 至高品质</p>
      </div>
    </div>
    <div class="product3">
      <img :src="require('@/assets/mobile/product3p.png')"/>
      <div class="desc">
        <div class="one">
          <p>4核1.2G高速处理器</p>
          <p>主芯片</p>
        </div>
        <div class="two">
          <p>-20℃~50℃</p>
          <p>工作温度</p>
        </div>
        <div class="three">
          <p>32A 七孔</p>
          <p>输出端</p>
        </div>
      </div>
    </div>
    <div class="product4">
      <img :src="require('@/assets/mobile/product4p.png')"/>
      <div class="desc">
        <div>
          <p>全国运维  快速响应</p>
          <p>专人定期巡检，无需担心充电盒被盗或被破坏，更安全</p>
        </div>
      </div>
    </div>
    <div class="product5">
      <div class="table">
        <div class="tr">
          <div>外观尺寸</div>
          <div>455mm*260mm*119mm</div>
        </div>
        <div class="tr">
          <div>输入电压</div>
          <div>176V～264V AC</div>
        </div>
        <div class="tr">
          <div>工作频率</div>
          <div>50Hz±5Hz</div>
        </div>
        <div class="tr">
          <div>额定电流</div>
          <div>32A</div>
        </div>
        <div class="tr">
          <div>额定功率</div>
          <div>7kW</div>
        </div>
        <div class="tr">
          <div>充电方式</div>
          <div>二维码</div>
        </div>
        <div class="tr">
          <div>充电接口</div>
          <div>充电枪（GB/T 20234.2-2015）</div>
        </div>
        <div class="tr">
          <div>枪线长度</div>
          <div>3米</div>
        </div>
        <div class="tr">
          <div>显示屏</div>
          <div>无</div>
        </div>
        <div class="tr">
          <div>安装方式</div>
          <div>壁挂/立柱</div>
        </div>
        <div class="tr">
          <div>工作环境</div>
          <div>－20℃～＋50℃  相对湿度5%～95%</div>
        </div>
        <div class="tr">
          <div>储存环境</div>
          <div>－40℃～＋85℃  相对湿度10%～95%</div>
        </div>
        <div class="tr">
          <div>海拔高度</div>
          <div>≤2000米</div>
        </div>
        <div class="tr">
          <div>适用场景</div>
          <div>户内户外</div>
        </div>
        <div class="tr">
          <div>安全保护</div>
          <div>漏电、过流、欠压、过压、板载防浪涌、防雷器（选配）</div>
        </div>
        <div class="tr">
          <div>IP等级</div>
          <div>IP54</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'product'
}
</script>
<style lang="less">
.mb-product-pile{
  width: 100%;
  img{
    width: 100%;
    height: 100%;
  }
  .product1{
    height: 5.58rem;
  }
  .product2{
    position: relative;
    height: 5.36rem;
    .desc{
      position: absolute;
      width: 100%;
      top: .43rem;
      left: 0;
      color: #000;
      text-align: center;
      >p{
        font-size: 12px;
        line-height: 16.5px;
        &:nth-child(1){
          font-size: 18px;
          line-height: 25px;
        }
        &:nth-child(2){
          font-size: 12px;
          line-height: 16.5px;
          margin-bottom: .12rem;
        }
        &:nth-child(3){
          font-size: 12px;
          line-height: 16.5px;
          color: #13E4E8;
        }
      }
    }
  }
  .product3{
    position: relative;
    height: 6.55rem;
    .desc{
      position: absolute;
      top: 1.05rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      >div{
        &.one{
          width: 2.7rem;
          padding: 0 .2rem
        }
        &.two{
          padding: 0 .4rem;
          border-left: 1px solid rgba(255, 255, 255, .3);
          border-right: 1px solid rgba(255, 255, 255, .3);
        }
        &.three{
          width: 1.9rem;
          padding: 0 .2rem;
        }
        >p{
          &:first-child{
            color: white;
            font-size: 14px;
            line-height: 20px;
          }
          &:last-child{
            text-align: center;
            color: rgba(255, 255, 255, .6);
            font-size: 9px;
            line-height: 12.5px;
          }
        }
      }
    }
  }
  .product4{
    position: relative;
    height: 5.38rem;
    .desc{
      position: absolute;
      top: 0;
      left: 0;
      padding:.48rem 0 0 0;
      color: #000;
      text-align: center;
      width: 100%;
      >div{
        p{
          &:first-child{
            font-size: 18px;
            color: #000;
            line-height: 25px;
          }
          &:last-child{
            font-size: 12px;
            color: #6D7278;
            line-height: 16.5px;
          }
        }
      }
    }
  }
  .product5{
    width: 100%;
    padding: .4rem .35rem .36rem;
    .table{
      border: 1px solid #979797;
      .tr{
        display: flex;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 1px solid #979797;
        }
        >div{
          color: #333;
          font-size: 12px;
          line-height: 16.5px;
          &:nth-child(1){
            width: 1.23rem;
            text-align: center;
            padding: .13rem 0;
          }
          &:nth-child(2){
            border-left: 1px solid #979797;
            width: 5.53rem;
            text-align: left;
            padding: .13rem .27rem;
            word-break:break-all;
          }
        }
      }
    }
  }
}
</style>
